import './DashboardV3.scss';
import React from "react";
import {observer} from "mobx-react-lite";
import {useStores} from "../../../stores";
import {CurrencyComponent} from "../../currency-component/CurrencyComponent.tsx";
import {DashboardSection} from "./DashboardSection.tsx";
import {KpiBoxedValues} from "../../kpi-boxed-values/KpiBoxedValues.tsx";
import {DashboardChatSection} from "./dashboard-chat-section/DashboardChatSection.tsx";
import {useChatAvailableForActiveDatabag} from "../../../pages/chat-agent/hooks/useChatAvailableForActiveDatabag";
import {getDashboardSectionConfig} from "~/components/dashboard/DashboardSectionConfig.tsx";

/**
 * Dashboard that uses only merge-1 links, without any databags in the url
 * Used by: franke
 */
export const DashboardV3: React.FC = observer(() => {
    const {authStore, p, bagStore} = useStores();
    const chatDatabagAvailability = useChatAvailableForActiveDatabag();

    const isSample = bagStore.isSample;
    const commonKpi = bagStore.kpi.common;
    const dashboardKpisValues = React.useMemo<{title: string, subtitle: React.ReactNode}[]>(() => [
        {
            title: isSample ? 'Suppliers for validation' : 'Suppliers',
            subtitle: commonKpi ? String(commonKpi.n_suppliers) : ''
        },
        {
            title: 'Categories',
            subtitle: commonKpi ? String(commonKpi.n_categories) : ''
        },
        {
            title: isSample ? 'Spend for validation' : 'Spend',
            subtitle: commonKpi ? <CurrencyComponent v={commonKpi.total_spend} nDigits={3}/> : ''
        },
    ], [isSample, commonKpi]);

    const CARDS = p.getVisibleCardsBySection(authStore);
    const data1SectionConfig = getDashboardSectionConfig('data_1')!;
    const data1SectionCards = CARDS['data_1'];
    const insights2SectionConfig = getDashboardSectionConfig('insights_2')!;
    const insights2SectionCards = CARDS['insights_2'];

    return <div className="dashboard-v3">
        {p.showCard('chat', authStore) &&
            !p.isDisabledCard('chat', bagStore.bag).disabled &&
            (!chatDatabagAvailability.isReady || chatDatabagAvailability.isAvailable) &&
            <DashboardChatSection/>
        }

        <KpiBoxedValues values={dashboardKpisValues}/>
        <DashboardSection
            title={data1SectionConfig.title}
            icon={data1SectionConfig.icon}
            cards={data1SectionCards}
        />
        <DashboardSection
            title={insights2SectionConfig.title}
            icon={insights2SectionConfig.icon}
            cards={insights2SectionCards}
        />
    </div>
});
